module.exports = __webpack_public_path__ + "img/training-playing.527fbe21.svg";